import React from "react";
import PropTypes from "prop-types";
import SimpleVirtualizedAutocomplete from "../../../../../../../../components/Dropdown/SimpleVirtualizedAutocomplete";
import { VIEW_COLUMNS } from "../../../../config/buildingColumnsConfig";

const AddBuildingRow = ({
  buildingOptions,
  addBuilding,
  newBuildingId,
  setNewBuildingId,
}) => {
  const handleOnChange = (event, newValue) => {
    if (newValue) {
      setNewBuildingId(newValue.buildingID);
      addBuilding(newValue.buildingID);
      setNewBuildingId(""); // Clear selection after adding.
    } else {
      setNewBuildingId("");
    }
  };

  return (
    <tr className="hover:bg-cyan-50 hover:shadow-md">
      <td className="px-2 py-1 border-b border-white text-center bg-white" />
      <td colSpan={VIEW_COLUMNS.length} className="border">
        <SimpleVirtualizedAutocomplete
          options={buildingOptions}
          value={
            buildingOptions.find(
              (option) => option.buildingID === newBuildingId
            ) || null
          }
          onChange={handleOnChange}
          optionKey="buildingID"
          optionLabel="buildingReference"
          placeholder="Select a building..."
          itemSize={40}
          maxVisibleItems={8}
          className="w-full py-1 px-2"
        />
      </td>
    </tr>
  );
};

AddBuildingRow.propTypes = {
  buildingOptions: PropTypes.array.isRequired,
  addBuilding: PropTypes.func.isRequired,
  newBuildingId: PropTypes.string.isRequired,
  setNewBuildingId: PropTypes.func.isRequired,
};

export default AddBuildingRow;
